/* sticky submenu
 ========================================================================== */

export default function addStickySubmenu() {
  const submenu = document.querySelector('[data-component="submenu"]');
  const submenuSticky = document.querySelector('[data-component="submenu-sticky"]');
  const header = document.querySelector('.header');

  if (!submenu || !submenuSticky) return;

  let lastScrollY = window.scrollY || 0;
  let ticking = false;

  const setState = () => {
    const currentScrollY = window.scrollY;
    const isScrollingUp = currentScrollY < lastScrollY;
    lastScrollY = currentScrollY;

    const isMobile = window.innerWidth < 1024;
    const headerHeight = header ? header.offsetHeight : 0;
    const submenuBottom = submenu.getBoundingClientRect().bottom;
    const isHeaderVisible = header?.classList.contains('header--visible');

    // Determine if the sticky submenu should be visible
    let shouldShowSticky;

    if (isMobile) {
      // Mobile: always consider header height
      shouldShowSticky = submenuBottom <= headerHeight;
    } else {
      // Desktop: header height only when header is visible (scroll up)
      shouldShowSticky = isHeaderVisible
        ? submenuBottom <= headerHeight
        : submenuBottom <= 0;
    }

    // Toggle sticky submenu state
    if (shouldShowSticky) {
      submenuSticky.classList.remove('is-fading-out');
      submenuSticky.classList.add('is-visible');
    } else {
      // Different behavior depending on scroll direction
      if (isScrollingUp) {
        submenuSticky.classList.add('is-fading-out');
        submenuSticky.classList.remove('is-visible');
      } else {
        submenuSticky.classList.remove('is-visible', 'is-fading-out');
      }
    }
  };

  // Smooth scroll performance with requestAnimationFrame
  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        setState();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('load', setState);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setState);
}